import { EditMenuPage } from "./EditMenuPage";
import {
  UseQueryOptions,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { useVenueQuery } from "@greeter-venue/api/Hooks";
import { Menu } from "@greeter/core";
import { Query } from "@greeter/query";
import { useGreeterVenueApi, useHiddenTabBar } from "@greeter/matter";

const menuKey = (venueId: string) => [venueId, "menu"];

function useMenusQuery(
  venueId: string,
  opts:
    | (Omit<
        UseQueryOptions<Menu[], Error, Menu[], string[]>,
        "initialData" | "queryFn" | "queryKey"
      > & { initialData?: (() => undefined) | undefined })
    | undefined
) {
  const { api } = useGreeterVenueApi();
  return useQuery({
    queryKey: menuKey(venueId),
    queryFn: () => {
      return api.fetchMenus();
    },
    ...opts,
  });
}

export function EditMenuPageApiHandler() {
  const queryClient = useQueryClient();
  const { api } = useGreeterVenueApi();
  const venue = useVenueQuery({ refetchOnWindowFocus: false });
  const menus = useMenusQuery(venue.data?.id ?? "", {
    enabled: venue.isSuccess,
  });

  const simpleMenu = Query.mapQuery<Menu[]>(menus);

  let singleMenu = Query.first(simpleMenu);

  useHiddenTabBar();

  return (
    singleMenu.type === "done" &&
    singleMenu.data && (
      <EditMenuPage
        menu={singleMenu as Query<Menu>}
        uploadAsset={async (f) => await api.uploadAsset({ data: f })}
        save={async (m) => {
          const updated = await api.updateMenu(m);

          if (venue.isSuccess)
            queryClient.refetchQueries({ queryKey: menuKey(venue.data.id) });

          return updated;
        }}
      />
    )
  );
}
